import { AxiosError } from 'axios';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { ActivityLog, ActivityLogDetails } from '../../domain/ActivityLog/entities';

export type ActivityLogListFilters = {
  dateUpdated: string[];
  fromDate: string;
  toDate: string;
  status: number; // status field
  statusDescription: string; // description of status
  type: number; // type field
  typeDescription: string; // description of type
  account: string;
  pageSize: number;
  pageOffset: number;
};

export interface ActivityLogState {
  selectedActivityLog: Nullable<ActivityLog>;
  onSelectActivityLog: (activityLogId?: number) => void;
  resetSelectedActivityLog: () => void;
  activityLogListFilters: Partial<ActivityLogListFilters>;
  onActivityLogListFiltersChange: (
    filters: Partial<ActivityLogListFilters>,
    toToggleFilterDrawer?: boolean,
    nextPage?: number,
    totalPage?: number,
  ) => void;
  activityLogListData?: Nullable<ActivityLog[]>;
  activityLogDetailsData?: Nullable<ActivityLogDetails>;
  loadingState: {
    isLoadingActivityLogList: boolean;
    isLoadingActivityLogDetails: boolean;
  };
  errorState: {
    activityLogListDataError?: AxiosError<
      APIGatewayResponse<unknown>,
      { code: string; type: string; param: string; message: string }
    >;
    activityLogDetailsError?: AxiosError<
      APIGatewayResponse<unknown>,
      { code: string; type: string; param: string; message: string }
    >;
  };
  // activity log filter drawer
  isActivityLogFilterDrawerOpen: boolean;
  toggleActivityLogFilterDrawer: () => void;
}

export enum ActivityLogActionTypes {
  GetActivityLogList = '@@ActivityLog/GET_ACTIVITY_LOG_LIST',
  SetActivityLogListFilter = '@@ActivityLog/SET_ACTIVITY_LOG_LIST_FILTERS',
  SetIsActivityFilterDrawerOpen = '@@ActivityLog/SET_IS_ACTIVITY_FILTER_DRAWER_OPEN',
  SetSelectedActivityLog = '@@ActivityLog/SET_SELECTED_ACTIVITY_LOG',
  GetActivityLogDetails = '@@ActivityLog/GET_ACTIVITY_LOG_DETAILS',
}
